import {
  IonBackButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {useLocation} from "react-router-dom";

import "./Page.css";
import React, {useState} from "react";
import {AuthContext} from "../../providers/authContext";

const AskidaBorcTahsilatBasarisiz: React.FC = () => {
  const { logo, kurumBilgileri } = React.useContext(AuthContext);
  const { search } = useLocation<any>();
  const [tahsilatHata, setTahsilatHata] = useState<string>();

  React.useEffect(() => {
    const params = new URLSearchParams(search);
    setTahsilatHata(params.get("errMsg")!);
    window.history.pushState(
      {},
      kurumBilgileri?.kisaTanim + " - Derman Ol Kampanyası",
      "/askidayardim"
    );
  }, []);

  return (
    <IonPage>
      <IonHeader translucent>
        <IonToolbar>
          <IonButtons slot="end">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle className="ion-text-sm-wrap">
            <IonItem className="ion-margin-top ion-margin-bottom">
              <img src={logo} style={{ maxWidth: "3em", height: "auto" }} />
              <IonText
                className="ion-padding-start"
                style={{ fontSize: "1.5em" }}
              >
                {kurumBilgileri?.kisaTanim} - Derman Ol Kampanyası Tahsilat Sonucu
              </IonText>
            </IonItem>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonItem>
          <IonGrid>
            <IonRow className="ion-text-start ion-align-items-center">
              <IonCol size="1">
                <img src="assets/denied.png" />
              </IonCol>
              <IonCol>
                <IonLabel>{tahsilatHata}</IonLabel>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="1" />
              <IonCol className="tips">
                <strong>💡 İşlem başarısız olma sebepleri:</strong>
                <ul>
                  <li>Kart bilgileriniz hatalı olabilir</li>
                  <li>Kartınızda yeterli bakiye olmayabilir</li>
                  <li>Kartınızın internet alışverişe kapalı olabilir</li>
                  <li>3D Secure şifrenizi yanlış girmiş olabilirsiniz</li>
                  <li>Kartınızın günlük/aylık limit aşımı olabilir</li>
                </ul>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default AskidaBorcTahsilatBasarisiz;
